import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { SignatureRequestStatusEnum, statusTextMap } from '../../models/signature-request.dict';

/**
 * Component to display the status of a signature request as a badge.
 */
@Component({
  selector: 'signature-request-status-badge',
  standalone: true,
  imports: [],
  templateUrl: './signature-request-status-badge.component.html',
  styleUrls: ['./signature-request-status-badge.component.scss']
})
export class SignatureRequestStatusBadgeComponent implements OnInit, OnChanges {
  public textStatus!: string;

  @Input() fontSize: string = '1rem';
  @Input() status!: SignatureRequestStatusEnum;

  private readonly statusTextMap = statusTextMap;

  ngOnInit(): void {
    this.textStatus = this.statusTextMap[this.status];
  }

  ngOnChanges(): void {
    this.textStatus = this.statusTextMap[this.status];
  }
}
